import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lms-group-activity-bar',
  templateUrl: './group-activity-bar.component.html',
  styleUrls: ['./group-activity-bar.component.scss']
})
export class GroupActivityBarComponent implements OnInit {
  @Input() licensesResume: any = {};
  notStarted: number;
  playing: number;
  finished: number;
  total: number;

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    if (this.licensesResume && this.licensesResume.total) {
      const { afterDemo = 0, beforeDemo = 0, completed = 0, created = 0, total } = this.licensesResume;
      this.total = total;
      this.playing = Math.round(((beforeDemo + afterDemo) / total) * 100);
      this.finished = Math.round((completed / total) * 100);
      this.notStarted = 100 - (this.playing + this.finished);
    }
  }
}
